module.exports = __webpack_public_path__ + "img/Mickies_Pizzeria@1x.8b5187c3.png";